module.exports = "<fuse-main></fuse-main>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main